import { render } from "./CourseTele.vue?vue&type=template&id=2b7fec95&scoped=true"
import script from "./CourseTele.vue?vue&type=script&lang=js"
export * from "./CourseTele.vue?vue&type=script&lang=js"

import "./CourseTele.vue?vue&type=style&index=0&id=2b7fec95&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7fec95"]])

export default __exports__